import { SeasonStore } from '@yarmill/types';

export function sortSeasonStores(a: SeasonStore, b: SeasonStore): number {
  return b.startYear - a.startYear;
}
